<template>
	<h3 class="container mx-auto lg:text-left text-center pt-6 sm:pt-0 sm:pl-0 relative font-bold uppercase text-gold text-2xl mb-5">{{ $t("personal-details.title") }}</h3>

	<section id="PersonalDetails"
		class="container mx-auto grid grid-flow-row grid-cols-1 lg:grid-flow-col lg:grid-cols-2">

		<section class="xs:w-full lg:w-max justify-self-center lg:justify-self-start relative">
			<img src="/img/photo@1x.webp"
				loading="lazy"
				alt=""
				width="0"
				height="0"
				class="w-11/12 mx-auto lg:pr-5 lg:pr-0 sm:w-full mb-5 md:mb-0 xl:max-w-xl lg:max-w-md" />

			<Social-Networks class="justify-evenly w-full" />
		</section>

		<section class="mx-auto w-11/12 sm:w-full mt-10 lg:mt-0">
			<section class="grid grid-flow-col grid-cols-2">
				<ul>
					<li v-for="(detail, index) in details"
						:key="index"
						class="mb-6">
						<div class="text-gold uppercase font-semibold text-xs mb-1 mt-5 tracking-tighter">{{ $te(detail.label) ? $t(detail.label) : detail.label }}</div>
						<div class="text-black uppercase font-bold text-md">{{ $te(detail.value) ? $t(detail.value) : detail.value }}</div>
					</li>
				</ul>

				<section class="lg:mx-auto sm:ml-auto sm:mr-5">
					<div class="text-gold uppercase font-semibold text-xs mb-1 mt-5 tracking-tighter">{{ $t("personal-details.technologies") }}</div>

					<img src="/img/technologies.webp"
						loading="lazy"
						alt="Technology used"
						width="245"
						height="300"
						style="height: auto; width: 245px; max-height: 300px;" />
				</section>
			</section>
		</section>
	</section>
</template>

<script>
import SocialNetworks from '@/components/SocialNetworks'

export default {
	name: 'PersonalDetails',

	components: { SocialNetworks },

	data() {
		return {
			details: [
				{
					label: 'personal-details.details.based-in',
					value: 'Portugal',
				},
				{
					label: 'personal-details.details.occupation',
					value: 'Software Engineer',
				},
				{
					label: 'personal-details.details.role',
					value: 'Full-Stack Developer',
				},
				{
					label: 'personal-details.details.strong-side',
					value: 'Front-End',
				},
				{
					label: 'personal-details.details.experience',
					value: 'personal-details.details.experience-value',
				},
			],
		}
	},
}
</script>